import React from "react";
import { Mail, Phone } from "lucide-react";

export default function LeadsPanel({ leads }) {
  return (
    <section className="admin-panel" data-testid="admin-leads-panel">
      <h2>Requests</h2>
      <p className="admin-panel-intro">New quote requests submitted through the public page.</p>
      <div className="leads-list">{leads.length ? leads.map((lead) => <article className="lead-card" key={lead.id} data-testid={`admin-lead-${lead.id}`}><div className="lead-card-header"><strong>{lead.name}</strong><time>{new Date(lead.created_at).toLocaleDateString()}</time></div><div className="lead-card-contact"><a href={`tel:${lead.phone}`}><Phone size={13} /> {lead.phone}</a><a href={`mailto:${lead.email}`}><Mail size={13} /> {lead.email}</a></div><p>{lead.service} · {lead.message || "No extra details"}</p></article>) : <p className="empty-state" data-testid="admin-empty-leads">No requests yet.</p>}</div>
    </section>
  );
}
